import React from 'react';

const rowCenterSpcBtween = (): React.CSSProperties => {
  return {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  };
};

export default rowCenterSpcBtween;
